module.exports = __webpack_public_path__ + "static/media/heart.f57745dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/game/bomber/life/heart.svg
// module id = 38
// module chunks = 0